"use client";

import {
	initialStartHours,
	initialGrades,
	initialMinutes,
	lessonStartHours,
	lessonMinutes,
	lessonGrades,
} from "../utils/paramators";
import { addLesson } from "@/app/actions";
import type { FormState } from "@/app/actions";
import { useState, useActionState, useEffect } from "react";
import { useFormStatus } from "react-dom";
import { toast } from "sonner";

function SubmitButton() {
	const { pending } = useFormStatus();
	return (
		<button
			type="submit"
			disabled={pending}
			className="mt-3 w-full rounded-md bg-green-600 p-2 text-lg font-bold text-white transition-colors duration-200 hover:bg-green-800"
		>
			{pending ? "登録中..." : "登録する"}
		</button>
	);
}

export default function LessonRegistrationForm() {
	// HTMLのinput typeのdateはyyyy-mm-dd形式なので変換
	const today: string = new Date()
		.toLocaleDateString("ja-JP", {
			year: "numeric",
			month: "2-digit",
			day: "2-digit",
			timeZone: "Asia/Tokyo",
		})
		.replace(/\//g, "-");

	const [selectedDate, setSelectedDate] = useState(today);

	const [selectedStartHours, setSelectedStartHours] =
		useState(initialStartHours);
	const [selectedMinutes, setSelectedMinutes] = useState(initialMinutes);
	const [selectedGrades, setSelectedGrades] = useState(initialGrades);

	const initialState: FormState = { success: false, error: undefined };
	const [formState, formAction] = useActionState(addLesson, initialState);

	useEffect(() => {
		if (formState?.error) {
			toast.error(formState.error);
		}
		if (formState.success === true && formState?.error === undefined) {
			toast.success("授業を登録しました");
		}
	}, [formState]);

	return (
		<div className="order-1 w-full lg:order-2 lg:w-1/2">
			<h2 className="pt-6 text-center text-3xl font-bold">授業登録</h2>
			<div className="px-3 pt-6 lg:px-12">
				<form
					action={formAction}
					className="space-y-2 rounded-lg border p-6 lg:space-y-3"
				>
					<div>
						<label
							htmlFor="date"
							className="mb-1 block text-base font-medium lg:text-lg"
						>
							日付
						</label>
						<input
							type="date"
							id="date"
							name="date"
							defaultValue={selectedDate}
							required
							className="w-full rounded-md border p-2"
							onChange={(e) => setSelectedDate(e.target.value)}
						/>
					</div>
					<div>
						<label className="mb-1 block text-base font-medium lg:text-lg">
							開始時間
						</label>
						<input
							type="hidden"
							name="startHours"
							value={selectedStartHours}
						/>
						<div className="flex flex-wrap gap-2">
							{lessonStartHours.map((startHours) => (
								<button
									key={startHours}
									type="button"
									onClick={() => setSelectedStartHours(startHours)}
									className={`min-w-max flex-1 rounded-md border p-2 ${
										selectedStartHours === startHours
											? "bg-blue-500 text-white"
											: "bg-white text-gray-400 transition-colors duration-200 hover:bg-gray-200"
									}`}
								>
									{startHours}
								</button>
							))}
						</div>
					</div>
					<div>
						<label className="mb-1 block text-base font-medium lg:text-lg">
							時間
						</label>
						<input type="hidden" name="minutes" value={selectedMinutes} />
						<div className="flex flex-wrap gap-2">
							{lessonMinutes.map((minutes) => (
								<button
									key={minutes}
									type="button"
									onClick={() => setSelectedMinutes(minutes)}
									className={`min-w-max flex-1 rounded-md border p-2 ${
										selectedMinutes === minutes
											? "bg-blue-500 text-white"
											: "bg-white text-gray-400 transition-colors duration-200 hover:bg-gray-200"
									}`}
								>
									{minutes}分
								</button>
							))}
						</div>
					</div>
					{selectedGrades.map((grade, index) => (
						<input
							key={index}
							type="hidden"
							name="grades"
							value={grade}
						/>
					))}
					{[1, 0, 0].map((value, index) => (
						<div key={index}>
							<label className="mb-1 block text-base font-medium lg:text-lg">
								{index + 1}人目
							</label>
							<div className="flex gap-2">
								{lessonGrades.slice(value).map((grade) => (
									<button
										key={grade}
										type="button"
										onClick={() =>
											setSelectedGrades((prev) => {
												const newStudents = [...prev];
												newStudents[index] = grade;
												return newStudents;
											})
										}
										className={`flex-1 rounded-md border p-2 ${
											selectedGrades[index] === grade
												? "bg-blue-500 text-white"
												: "bg-white text-gray-400 transition-colors duration-200 hover:bg-gray-200"
										}`}
									>
										{grade}
									</button>
								))}
							</div>
						</div>
					))}
					<SubmitButton />
				</form>
			</div>
		</div>
	);
}
